module.exports = __webpack_public_path__ + "static/media/typing-practicer-small.39aa08e9.png";